import React from 'react';
import { Button, Form } from 'react-bootstrap';
import './ContactMe.css'


const ContactMe = () => {


    return (
        <div>
            <h2 id='connect' className="text-center mt-5 mb-5">Let's Connect</h2>
            <div className="form-container mb-5 d-flex justify-content-center">
                <Form className='w-50 '>
                    <Form.Group controlId="formBasicEmail">
                        <Form.Label>Name</Form.Label>
                        <Form.Control type="text" placeholder="Enter name" required />
                    </Form.Group>

                    <Form.Group controlId="formBasicEmail">
                        <Form.Label>Email address</Form.Label>
                        <Form.Control type="email" placeholder="Enter email" required />
                        <Form.Text className="text-muted">
                            We'll never share your email with anyone else.
                    </Form.Text>
                    </Form.Group>

                    <Form.Group controlId="formBasicEmail">
                        <Form.Label>Message</Form.Label>
                        <Form.Control as="textarea" type="text" placeholder="Enter your message" required />
                    </Form.Group>
                    <div className="d-flex justify-content-center">
                        <Button className='' variant="info" type="submit">Send</Button>
                    </div>

                </Form>
            </div>

        </div>
    );
};

export default ContactMe;